/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserLastActivity404ResponseParams } from './userLastActivity404ResponseParams';


export interface UserLastActivity404Response { 
    message: string;
    params: UserLastActivity404ResponseParams;
}

